import Cookies from 'js-cookie'

const DEFAULT_OPTIONS = {
  path: '/',
  sameSite: 'Mobius Social'
}
const APP_WEB_FALLBACK_PREFIX = 'mobius-web-cookie:'

export const TokenKey = 'ms-token'
export const DeviceIdKey = 'ms-deviceId'
export const DeviceInfoKey = 'ms-deviceInfo'
export const LanguageKey = 'ms-language'
export const ClientPlatformKey = 'ms-clientPlatform'
export const UserInfoKey = 'ms-userInfo'

// 判断当前浏览器环境是否允许使用 localStorage 作为 Cookie 兜底。
const canUseFallbackStorage = () => {
  try {
    return typeof window !== 'undefined' && Boolean(window.localStorage)
  } catch (error) {
    return false
  }
}

// 写入 H5 同源 localStorage 兜底登录态，避免 iframe Cookie 不可用而丢失 Authorization。
const setAppWebFallbackCookie = (name, value) => {
  if (!canUseFallbackStorage()) return
  try {
    window.localStorage.setItem(`${APP_WEB_FALLBACK_PREFIX}${name}`, String(value ?? ''))
  } catch (error) {
    console.warn('AppWeb 登录态兜底写入失败:', error)
  }
}

// 读取 H5 同源 localStorage 兜底登录态，避免 iframe Cookie 不可用而丢失 Authorization。
const getAppWebFallbackCookie = (name) => {
  if (!canUseFallbackStorage()) return undefined
  try {
    const value = window.localStorage.getItem(`${APP_WEB_FALLBACK_PREFIX}${name}`)
    return value === null ? undefined : value
  } catch (error) {
    console.warn('AppWeb 登录态兜底读取失败:', error)
    return undefined
  }
}

// 清理 H5 同源 localStorage 兜底登录态，避免退出后残留旧 Authorization。
const removeAppWebFallbackCookie = (name) => {
  if (!canUseFallbackStorage()) return
  try {
    window.localStorage.removeItem(`${APP_WEB_FALLBACK_PREFIX}${name}`)
  } catch (error) {
    console.warn('AppWeb 登录态兜底清理失败:', error)
  }
}

export function setCookie(name, value, options = {}) {
  setAppWebFallbackCookie(name, value)
  return Cookies.set(name, value, { ...DEFAULT_OPTIONS, ...options })
}

export function getCookie(name) {
  return Cookies.get(name) || getAppWebFallbackCookie(name)
}

export function removeCookie(name, options = {}) {
  removeAppWebFallbackCookie(name)
  return Cookies.remove(name, { ...DEFAULT_OPTIONS, ...options })
}

export function getToken() {
  return getCookie(TokenKey)
}

export function getDeviceId() {
  return getCookie(DeviceIdKey)
}

// 从 Cookie 中读取设备信息（JSON 字符串）
export function getDeviceInfo() {
  const raw = getCookie(DeviceInfoKey)
  if (!raw) {
    return null
  }
  try {
    return JSON.parse(raw)
  } catch (error) {
    console.warn('设备信息解析失败:', error)
    return null
  }
}

// 从 Cookie 中读取语言
export function getLanguage() {
  return getCookie(LanguageKey)
}

export default {
  setCookie,
  getCookie,
  removeCookie,
  getToken,
  getDeviceId,
  getDeviceInfo,
  getLanguage,
  TokenKey,
  DeviceIdKey,
  DeviceInfoKey,
  LanguageKey,
  ClientPlatformKey,
  UserInfoKey
}
